// extracted by mini-css-extract-plugin
export default {"w-full":"Chart_w-full__iQGEw","chart":"Chart_chart__7k5Un"};